'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isThenable(obj) {
  return obj && typeof obj.then === 'function';
}

exports.default = isThenable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-6.17/js/lib/isThenable.js
// module id = 600
// module chunks = 3 4 5